import React, {useEffect, useState} from "react"
import {EmailShareButton, FacebookShareButton} from "react-share"
import Image from "next/image"

import Typography from "../reusable/Typography/Typography"

type Props = {
    t: (_: string) => string
    className?: string
}

const DesktopSocialShare = ({t, className}: Props): React.ReactElement => {
	const [urlToShare, setUrlToShare] = useState<string | null>(null)

	useEffect(() => {
		setUrlToShare(window.location.href)
	}, [])

	const handleCoppyButton = () => {
		navigator.clipboard.writeText(urlToShare).then()
	}

	return (
		<div className={`row align-items-center ${className}`}>
			<Typography className="col-auto me-2 p-2"
				variant="bodyLg"
				semanticTag="span">{t("Share")}:</Typography>
			<FacebookShareButton className="col-auto d-flex me-1 p-2"
				url={urlToShare}>
				<Image src="/assets/icons/share/facebook.svg"
					width={24}
					height={24}/>
			</FacebookShareButton>
			<EmailShareButton className="col-auto d-flex me-1 p-2"
				url={urlToShare}>
				<Image src="/assets/icons/share/mail.svg"
					width={24}
					height={24}/>
			</EmailShareButton>
			<span className="col-auto pointer d-flex p-2"
				onClick={handleCoppyButton}>
				<Image src="/assets/icons/share/copy.svg"
					width={24}
					height={24}/>
			</span>
		</div>
	)
}

export default DesktopSocialShare
